export const poiType1 = {
  "4-30": [107785.8672, 122627.6953, 246.707184],
  // "4-31": [71833.246193, 86279.048621, 382.673745],
  "4-32": [94814.345884, 115954.87386, 638.519227]
}
export const poiType2 = {
  "1-2": [75669.312529, 118248.326052, 548.116229],
  "1-3": [71091.903254, 112111.705063, 501.810721],
  "1-4": [79428.34997, 121111.087913, 443.56702]
}
